import { render, staticRenderFns } from "./FundOrgDeals.vue?vue&type=template&id=6f450568&"
import script from "./FundOrgDeals.vue?vue&type=script&lang=js&"
export * from "./FundOrgDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports